import {
  byKey, checkExtent, createMenuItem, layerButtonClicked
} from './functions'
import { handleSessionTimeout, setLogoutUrl, setSessionTimeoutUrl } from './login'
import {
  map, getEpsg, initialPositionSource, setInitialPositionSource
} from './map/tools'
import { decisionsBeforeLogin, reindriftOrAr5 } from './rein_ar5'
import { rest } from './server'
import { locallyAr5, preventUserFromEditing, setRemotelyAr5 } from './storage'
import { token } from './tokens'

import { boundingExtent } from 'ol/extent';
import { transformExtent } from 'ol/proj';

import getLayersTemplate from '/requests/getLayersRequest.json'

export const getLayerGroup = () => {
  const g = import.meta.env.VITE_GROUP;
  if (g) getLayersTemplate.layergroup = Number(g);
  decisionsBeforeLogin(getLayersTemplate.layergroup)
};

export const getLayers = () => {
  const data = getLayersTemplate;
  $.ajax({
    type: 'POST',
    url: rest + '/edit_layers_request' + token,
    data: JSON.stringify(data),
    success: data => {
      const editableLayers = data.editLayersResLayerEntities;
      const itIsAr5 = reindriftOrAr5(editableLayers);
      setRemotelyAr5(itIsAr5);
      const whoIsLoggedIn = data.login_organization;
      const r = data.redirectUrlSeesionTimeout;
      r && setLogoutUrl(r);
      let qualityCheckIsEnabled = false;
      if (data.quality_check_period && data.quality_check_button) {
        qualityCheckIsEnabled = true;
      }
      const canEditDuring = (['Fylkesmannen', 'NIBIO'].indexOf(whoIsLoggedIn) > -1);
      // if (data.quality_check_period && whoIsLoggedIn !== 'Fylkesmannen') {
      if (data.quality_check_period && !canEditDuring) {
        preventUserFromEditing();
        // console.log('Quality check is going on, never enable edit-button.');
      }
      editableLayers.sort(byKey('sortKey'));
      // editableLayers.sort(bySortKey);

      editableLayers.forEach((value, index) => {
        // console.log('index, value:', index, value);
        createMenuItem(index, value);
      });

      // Activate quality check button for non-distrikt users
      if (qualityCheckIsEnabled) { // then show button
        const qcb = document.getElementById('showChangesOverviewBtn');
        if (qcb.className.slice(-4) === 'hide') {
          qcb.className = qcb.className.slice(0, -5); // remove hide
        }
        if (itIsAr5) { // move quality check button to a visible tab
          const h = document.getElementById('ar5QualityCheckBtnInsideHere');
          if (h) h.append(qcb);
        }
      }

      // it does not work, but it has to be called at least once
      $('.dropdown-button').dropdown('open');
      // workaround for first hover to work
      $('.parent-button').click();
      $('.dropdown-content').hide(); // hide all

      $('.layer-button').click(function() { layerButtonClicked($(this)); });

      const numberOfLayers = editableLayers.length;
      if (numberOfLayers === 1) { // AR5
        // Do not show header
        // Automatically click on the only layer button:
        document.getElementsByClassName('layer-button')[0].click();
      } else if (numberOfLayers > 1) {
        document.getElementById('main-navigation').style = 'display:block';
        document.getElementById('tabs').style.height = '48px';
        document.getElementById('map').style.top = '48px';
        document.getElementById('map').style.height = 'calc(100% - 48px)';
      }

      $('.root').hover(function() {
        $('.dropdown-content').hide(); // hide all
      });

      $('.dropdown-button').keydown(function(e) {
        var code = e.keyCode || e.which;
        if (code === 27){ // Esc pressed
          $('.dropdown-content').hide();
        }
      });

      let canClose = false
      $('.parent-button').hover(
        function () { // cannot use arrow function, because 'this' cahnges meaning
          $('.dropdown-content').hide(); // hide all
          if (canClose) return;
          const id = $(this).attr('id');
          $('#dd-'+id).show();
          // $(this).dropdown('open');
        },
        () => { canClose = false; }
      );
      $('.parent-button').click( function() {
        const id = $(this).attr('id');
        $('#dd-'+id).hide();
        canClose = true;
      });

      if (!data.envelope) return;
      const receivedGeometry = data.envelope.coordinates['0'];
      let extent = boundingExtent(receivedGeometry);
      // extent = transformExtent(extent, 'EPSG:4326', 'EPSG:25832');

      // Store initial extent as an attribute inside the html element:
      const zh = document.getElementById('zoomHome');
      zh.setAttribute('data-initialExtent', extent);

      const hele = locallyAr5 ? false : checkExtent(extent);
      extent = transformExtent(extent, 'EPSG:4258', getEpsg());
      if (!hele && initialPositionSource !== 'url'){
        setInitialPositionSource('back-end');
        map.getView().fit(extent, map.getSize());
        // console.log('zooming closer, remove it when done');
        // const v = map.getView();
        // v.setZoom(v.getZoom() + 2);
      }
      setSessionTimeoutUrl(data.redirectUrlSeesionTimeout);
    },
    error: handleSessionTimeout,
    contentType: 'application/json',
    dataType: 'json'
  });
};

